export default __webpack_public_path__ + "assets/images/summer-c8adc6ec.png";